import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryShowcase() {
  return (
    <section className="py-16 md:py-24 px-6 max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="text-center mb-14">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
          热门分类
        </h2>
      </div>

      {/* Category Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative aspect-square rounded-lg overflow-hidden bg-background-100 hover:bg-background-200 transition-colors cursor-pointer flex flex-col items-center justify-center gap-4"
          >
            {/* Icon Circle */}
            <div className={`w-14 h-14 md:w-16 md:h-16 rounded-full ${cat.color} flex items-center justify-center`}>
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>

            {/* Label */}
            <div className="text-center">
              <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-foreground-50 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {cat.count}部作品
              </p>
            </div>

            {/* Bottom glow on hover */}
            <div className="absolute inset-x-0 bottom-0 h-1 bg-primary-500 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300" />
          </Link>
        ))}
      </div>
    </section>
  );
}